import { Container } from "@mui/material";
import { ReactNode } from "react";

type PageContainerProps = {
  children: ReactNode;
};

function PageContainer({ children }: PageContainerProps) {
  return (
    <Container
      maxWidth="md"
      sx={{
        padding: { xs: 0, sm: 0 },
        backgroundColor: "background.primary",
      }}
    >
      {children}
    </Container>
  );
}

export default PageContainer;
